import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    font-family: var(--sds-typography-family-body);
  }

  .custom-color-picker-content {
    overflow: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
    max-width: 700px;
  }

  @media (max-width: 768px) {
    .custom-color-picker-content {
      gap: var(--sds-size-space-600);
      grid-template-columns: 1fr;
    }
  }

  .color-column-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--sds-size-space-600);
    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    width: 100%;
  }

  .preview-column-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--sds-size-space-600);
    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    padding: var(--sds-size-space-800); /* Only preview card has 24px padding */
  }

  .preview-text {
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1;
    margin: 0;
    text-align: center;
  }

  .preview-rectangle {
    display: flex;
    height: 40px;
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    justify-content: center;
    align-items: center;
    border-radius: var(--sds-size-radius-400);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-semibold);
    line-height: 1;
  }

  .validation-error {
    color: var(--sds-color-text-danger-default);
    font-size: var(--sds-typography-body-size-small);
    text-align: center;
    margin-top: var(--sds-size-space-400);
    padding: var(--sds-size-space-400);
    background-color: var(--sds-color-background-danger-tertiary);
    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-danger-default);
  }

  /* Loading and error states */
  .color-column-card[aria-busy="true"],
  .preview-column-card[aria-busy="true"] {
    opacity: 0.6;
    pointer-events: none;
  }

  .color-column-card[aria-disabled="true"],
  .preview-column-card[aria-disabled="true"] {
    opacity: 0.4;
    pointer-events: none;
  }

  /* Focus management for accessibility */
  .color-column-card:focus-within,
  .preview-column-card:focus-within {
    outline: var(--sds-size-stroke-focus-ring) solid var(--sds-color-border-brand-default);
    outline-offset: var(--sds-size-space-100);
  }
`;
